import { patchCommercialOrderConfirm, patchResearchOrderConfirm, } from "@erp/shared/api/generated/wrappers/order";
import { postCommercialOrderConfirm, postResearchOrderConfirm, } from "@erp/shared/api/generated/wrappers/order";
import { isValidId } from "@erp/shared/utils/https/is-valid-id";
import { toValue } from "@erp/shared/utils/to-value";
import { parseCalcJson, parseTotalPrice, } from "@erp/shared/components/ui/Document/_utils/calc-cost-row";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { useState } from "@erp/shared/composables/useState";
import { showAlert } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation, useQuery } from "@tanstack/vue-query";
import { computed } from "vue";
import { queries } from "@erp/shared/queries";
/**
 * @param orderId 발주서 아이디
 * @returns 발주서 조회, 등록, 수정, 발주서 제품 조회
 */
export const useOrderConfirmAction = (isCommercial = true) => {
    const isCommercialRef = toValue(isCommercial);
    const [orderId, setOrderId] = useState(null);
    const { invalidateQueries } = useInvalidateQueries();
    const readQueryOptions = computed(() => {
        const orderIdValue = orderId.value ?? 0;
        return {
            ...queries.order.confirmWithProduct(isCommercialRef.value, orderIdValue),
            enabled: !!orderId.value,
        };
    });
    /**
     * @description 특정 발주서 조회
     */
    const readQuery = useQuery(readQueryOptions);
    /**
     * @description 발주서 생성
     */
    const createMutation = useMutation({
        mutationFn: async ({ body }) => isCommercialRef.value
            ? await postCommercialOrderConfirm(body)
            : await postResearchOrderConfirm(body),
        onSuccess: () => {
            invalidateQueries([queries.order._def, queries.project._def]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "발주서 등록 실패");
        },
    });
    /**
     * @description 특정 발주서 수정
     */
    const updateMutation = useMutation({
        mutationFn: async ({ body }) => {
            if (!isValidId(orderId.value)) {
                throw new Error("수정할 발주서 ID가 유효하지 않습니다.");
            }
            return isCommercialRef.value
                ? await patchCommercialOrderConfirm(orderId.value, body)
                : await patchResearchOrderConfirm(orderId.value, body);
        },
        onSuccess: () => {
            invalidateQueries([queries.order._def, queries.project._def]);
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "발주서 수정 실패");
        },
    });
    const orderConfirmCalcJson = computed(() => {
        const raw = readQuery.data?.value?.productCalcJson;
        return parseCalcJson(raw);
    });
    const totalPrice = computed(() => {
        return parseTotalPrice(readQuery.data?.value?.productCalcJson);
    });
    return {
        orderId,
        readQuery,
        createMutation,
        updateMutation,
        orderConfirmCalcJson,
        totalPrice,
        setOrderId,
    };
};
